import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import PageManageModal from '../../../molecules/page-manage/page-manage-modal';
import { ManageThankYouConsumer } from '../thank-you-manage-view/ThankYouManageContext';

const ThankYouDeleteModal = function ThankYouDeleteModal(props) {
    const { page } = props;

    const [error, setError] = useState('');
    const [showDelete, _setShowDelete] = useState(false);

    const showDeleteRef = useRef(showDelete);
    const setShowDelete = (value) => {
        showDeleteRef.current = value;
        _setShowDelete(value);
    };

    const [modalStyle, setModalStyle] = useState({});
    const buttonRef = useRef({});

    const deleteClickHandler = (list, updateList, thankYouPageKey) => {
        const { protocol, host } = new URL(window.location.href);
        const query = `${protocol}//${host}/odata/thankyoupages/${thankYouPageKey}`;

        fetch(query, { method: 'DELETE' })
            .then((response) => {
                if (response.ok) {
                    return response;
                }

                throw Error(response.statusText);
            })
            .then(() => {
                const newList = [...list];
                const index = newList.indexOf(newList.find((r) => r.Key === thankYouPageKey));

                newList.splice(index, 1);
                updateList(newList);
            })
            .catch((err) => {
                setError(`Something went wrong. Please try again later - ${err}`);
            });
    };

    useEffect(() => {
        const viewportOffset = buttonRef.current.getBoundingClientRect();

        // default positioning
        // modal height is 223 and half is 111-ish;
        const modalPositionOffset = 223;

        // relative top and bottom positions of the trigger button
        const relativeBottom = viewportOffset.bottom;
        const relativeTop = viewportOffset.top;

        const docHeight = document.documentElement.offsetHeight;
        let modalTop = relativeTop - (modalPositionOffset / 2);

        if (docHeight - relativeBottom < 350) {
            // set a limit of 350px (subject to change) so them modal does not get cut off
            modalTop = docHeight - (modalPositionOffset / 2) - 350;
        }

        setModalStyle({
            position: 'fixed',
            top: modalTop,
            left: 40,
        });
    }, [showDelete]);

    const removeButton = () => (
        <button ref={buttonRef} id={`remove-${page.Title}`} key={`remove-${page.Title}`} className="button" type="button" onClick={() => setShowDelete(true)} style={{ minWidth: 40, minHeight: 40 }}>
            <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: 'large' }} />
        </button>
    );

    const content = (list, updateList, thankYouPageKey) => (
        <div className="box" style={{ minHeight: 100 }}>
            <span className="is-size-6">
                {`Are you sure you want to remove ${page.Title}?`}
            </span>
            <ul className="is-size-7">
                <li>
                    All related appeal will be automatically
                    re-linked to your default thank you page
                </li>
                <li>Any changes you have made to this page will be lost</li>
            </ul>
            <p className="is-size-7" style={{ color: 'red' }}>{error}</p>
            <button onClick={() => deleteClickHandler(list, updateList, thankYouPageKey)} type="button" className="button is-info" style={{ marginTop: 20 }}>Remove</button>
        </div>
    );

    return (
        <ManageThankYouConsumer>
            {({ list, updateList }) => (
                <PageManageModal
                    key={`remove-modal-${page.Title}`}
                    button={removeButton()}
                    content={content(list, updateList, page.Key)}
                    title="Confirm Delete"
                    confirmButtonText=""
                    show={showDeleteRef.current}
                    setShow={setShowDelete}
                    modalcardstyle={modalStyle}
                />
            )}
        </ManageThankYouConsumer>
    );
};

ThankYouDeleteModal.propTypes = {
    page: PropTypes.shape({
        Key: PropTypes.string,
        Title: PropTypes.string,
    }).isRequired,
};

ThankYouDeleteModal.defaultProps = {
};

export default ThankYouDeleteModal;
